import React from 'react';
import { Link } from 'react-router-dom';
import styles from './acknowledgement.module.css';

function Acknowledgement(): JSX.Element {
  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Thank You For Dronuting!</h1>
      <p className={styles.message}> Your order has been placed successfully and will be arriving by drone in 16 minutes. </p>
      <Link className={styles.placeorder} to={{ pathname: '/map' }}>Go to the Map</Link>
    </div>
  );
}

export default Acknowledgement;
